import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

/**
 * Coming Soon Component
 * Displayed for features that are not yet implemented
 */
@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="coming-soon-container">
      <div class="coming-soon-content">
        <i class="pi pi-hourglass" style="font-size: 4rem; color: #667eea;"></i>
        <h1>Funzionalità in Arrivo</h1>
        <p class="description">
          Questa funzionalità non è ancora disponibile.<br>
          Stiamo lavorando per renderla disponibile il prima possibile.
        </p>
        <button 
          class="back-button"
          (click)="goBack()"
          aria-label="Torna indietro"
        >
          <i class="pi pi-arrow-left"></i>
          Torna Indietro
        </button>
      </div>
    </div>
  `,
  styles: [`
    .coming-soon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: calc(100vh - 100px);
      padding: 2rem;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    }
    
    .coming-soon-content {
      text-align: center;
      background: white;
      padding: 3rem;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      max-width: 600px;
    }
    
    .coming-soon-content h1 {
      margin: 1.5rem 0 1rem;
      font-size: 2rem;
      color: #2c3e50;
      font-weight: 600;
    }
    
    .description {
      color: #7f8c8d;
      font-size: 1.1rem;
      line-height: 1.6;
      margin-bottom: 2rem;
    }
    
    .back-button {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem 1.5rem;
      background: #667eea;
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    
    .back-button:hover {
      background: #5568d3;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
    
    .back-button:active {
      transform: translateY(0);
    }
    
    @media (max-width: 768px) {
      .coming-soon-content {
        padding: 2rem 1.5rem;
      }
      
      .coming-soon-content h1 {
        font-size: 1.5rem;
      }
      
      .description {
        font-size: 1rem;
      }
    }
  `]
})
export class ComingSoonComponent implements OnInit {
  constructor(
    private router: Router,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    // WCAG 9.2.4.2: Set descriptive page title
    this.titleService.setTitle('Funzionalità in Arrivo - Portale Fiduciari AXA');
  }

  goBack(): void {
    // Try to go back in history, fallback to dashboard
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.navigate(['/axa/dashboard']);
    }
  }
}
